// frontend/src/hooks/useThemeToggle.js
//
// The one-click light/dark switch: flips the current theme to the other half
// of its family (theme.js THEME_FAMILIES), so a navy merchant toggles to sky,
// never to classic light.
//
// Reads the theme from <html data-theme=…> (single source of truth, mutated
// synchronously by applyTheme()) rather than userContext.user.theme_mode,
// which lags by one PATCH round-trip — the label and the icon change on the
// same paint as the click.

import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { themeFamily } from '../theme';
import useDataTheme from './useDataTheme';

/**
 * @returns {{ isLight: boolean, label: string, toggle: () => void }}
 *   `label` names what the click does ("Dark mode" while light).
 */
export default function useThemeToggle() {
  const { t } = useTranslation();
  const { updateTheme } = useAuth();
  const theme = useDataTheme();
  const family = themeFamily(theme);
  const isLight = family.light === theme;
  return {
    isLight,
    label: t(isLight ? 'topMenu.darkMode' : 'topMenu.lightMode'),
    toggle: () => updateTheme(isLight ? family.dark : family.light),
  };
}
